import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function QuickActionCards({ volunteerStatus }) {
  const navigate = useNavigate();
  const isNew = volunteerStatus === 'new';

  const actions = [
    {
      icon: 'BookMarked',
      title: 'Book Training Courses',
      description: isNew
        ? 'You are a new volunteer! Enroll in orientation and foundational training courses to get started.' :'Browse and enroll in available training sessions to advance your skills.',
      cta: 'Book a Course',
      route: '/training-courses-catalog',
      highlight: isNew,
      badge: isNew ? 'Recommended' : null,
      badgeColor: 'bg-accent text-white',
    },
    {
      icon: 'Library',
      title: 'View All Courses',
      description: 'Explore the full training catalog including upcoming sessions, topics, and schedules.',
      cta: 'Browse Catalog',
      route: '/training-courses-catalog',
      highlight: false,
      badge: null,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {actions?.map((action) => (
        <div
          key={action?.title}
          className={`relative bg-card border rounded-xl p-5 md:p-6 shadow-sm transition-shadow hover:shadow-md ${
            action?.highlight ? 'border-blue-400 ring-1 ring-blue-200' : 'border-border'
          }`}
        >
          {action?.badge && (
            <span className={`absolute top-4 right-4 text-xs font-caption font-semibold px-2 py-0.5 rounded-full ${action?.badgeColor}`}>
              {action?.badge}
            </span>
          )}
          <div className="flex items-start gap-4">
            <div className={`w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${action?.highlight ? 'bg-blue-100' : 'bg-muted'}`}>
              <Icon name={action?.icon} size={22} color={action?.highlight ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">{action?.title}</h3>
              <p className="text-xs md:text-sm font-caption text-muted-foreground leading-relaxed mb-4 line-clamp-3">
                {action?.description}
              </p>
              <Button
                variant={action?.highlight ? 'default' : 'outline'}
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                iconSize={14}
                onClick={() => navigate(action?.route)}
              >
                {action?.cta}
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}